// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5204":"4b70f2a5","5782":"b6d70103","6705":"4b70f2a5","6996":"cf4231c9","9925":"2aa3be2f"}[chunkId] + ".chunk.css";
};